exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--Form__2ZgVd{-webkit-box-sizing:border-box;box-sizing:border-box}\n", ""]);

// exports
exports.locals = {
	"Form": "styles--Form__2ZgVd",
	"form": "styles--Form__2ZgVd"
};